module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic07.3c332a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic07.png
// module id = 525
// module chunks = 1